import React, {useEffect, useState} from 'react'
import logo from "../assetes/logo.png";
import InfosPartner from './InfosPartner.jsx';
import AdminNotizenPartner from './AdminNotizenPartner.jsx';
import HochladenPartner from './HochladenPartner.jsx';
import FotosPartner from './FotosPartner.jsx';
import { useDispatch, useSelector } from 'react-redux';
import { getAllPartner, getOnePartner } from '../redux/apiCalls/accidentApiCall.js';
import { useNavigate, useParams } from 'react-router-dom';
function PartnerEye() {
    const [activeComponent, setActiveComponent] = useState("Infos");
    const renderActiveComponent = () => {
      switch (activeComponent) {
        case "Infos":
          return <InfosPartner />;
        case "AdminNotizen":
          return <AdminNotizenPartner />;
        case "Hochladen":
          return <HochladenPartner />;
        case "Fotos":
          return <FotosPartner />;
        default:
          return null;
      }
    };
  const dispatch = useDispatch();
    const { accident, isloading, numberOfAccidents } = useSelector((state) => state.accident);
    const { accidents } = useSelector((state) => state.accident);
    const navigate = useNavigate();
    const [perPage] = useState(9);
    const [currentPage, setCurrentPage] = useState(1);
    useEffect(() => {
      dispatch(getAllPartner(currentPage, perPage)).then((response) => {
        console.log("API Response:", response); 
      });
    }, [dispatch, currentPage, perPage]);
  
    const user = JSON.parse(sessionStorage.getItem("user"));
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    address: "",
    city: "",
    phoneNumber:"",
    description: "",
    iban: "",
    accountInfo: "",
    username: "",
    profilePhoto: "",
  });
  const { id } = useParams();
  const {partner, getLoading} = useSelector((state) => state.accident);
  useEffect(() => {
    if (id) {
      dispatch(getOnePartner(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (partner !== null) {
      
      setUserData({
        name: partner?.user.name || "",
        email: partner?.user.email || "",
        address: partner?.user.address || "",
        city: partner?.user.city || "",
        phoneNumber: partner?.user.phoneNumber || "",
        description: partner?.user.description || "",
        iban: partner?.user.iban || "",
        accountInfo: partner?.user.accountInfo || "",
        username: partner?.user.username || "",
        profilePhoto: partner?.user.profilePhoto?.url || ""
      });
    }
  }, [partner]);
  
  if(!partner){
    return <div>loading...</div>
  }
    
    return (
        <div className='flex flex-col w-[100%] h-[100vh] element'>
        <div className='flex flex-col w-[100%]'>
            <div className="pl-[20px] flex text-center justify-between w-[100%] pt-[10px] items-center">
                <div className='flex'>
                    <h1 class="font-[montserrat] text-2xl font-[900] flex items-center"><h1 className="mr-[10px]">{userData.name}</h1>Partner Übersicht</h1>
                </div>
            <div className="flex mr-[20px] justify-between">
                <div className="flex items-center">
                    <div className="text-center md:text-right">
                        <h4 className="text-[14px]">{user.username}</h4>
                        <p className="text-[12px] text-[#555]">{user.role}</p>
                    </div>
                    <div className="w-[50px] h-[50px] rounded-[50%] border-[1px] border-[#333] justify-center items-center flex ml-[10px]">
                        <img src={logo} alt='img-pro' className="w-[70%] h-[70%]" />
                    </div>
                    </div>
                </div>
            </div>
                <div className="border-b-[1px] border-b-[black] w-[100%] mt-[15px]"></div>
        </div>
    <div className="pt-[40px]">
      <table className="min-w-full border border-gray-300">
        <thead className="bg-gradient-to-b from-[#3a3a3a] to-[#1a1a1a] text-white">
          <tr>
            <th className="px-4 py-2 text-left border-b border-gray-400 cursor-pointer" onClick={() => setActiveComponent("Infos")}>Infos</th>
            <th className="px-4 py-2 text-left border-b border-gray-400 cursor-pointer" onClick={() => setActiveComponent("AdminNotizen")}>Admin Notizen</th>
            <th className="px-4 py-2 text-left border-b border-gray-400 cursor-pointer" onClick={() => setActiveComponent("Hochladen")}>Hochladen</th>
            <th className="px-4 py-2 text-left border-b border-gray-400 cursor-pointer" onClick={() => setActiveComponent("Fotos")}>Fotos</th>
          </tr>
        </thead>
      </table>
      <div className="">{renderActiveComponent()}</div>
    </div>
    </div>
    )
}

export default PartnerEye
